// import { Button } from 'libs/ui';
import { Content } from './preview.styled';

export const Preview = (props) => {
  const { data, loading } = props;
  const img = 'data:image/png;base64, ' + data;
  const cl = loading ? 'loading' : '';

  return (
    <Content className={cl}>
      {data && <img src={img} alt="Тест билета" />}
      {/* <Button onClick={close}>Закрыть</Button> */}
    </Content>
  );
};
